(function() {
  if (window.FAWishlist) return;

  var STORAGE_KEY = 'fa_wishlist';

  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch(e) { return []; }
  }

  function saveList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      dispatch();
    } catch(e) {}
  }

  function dispatch() {
    var list = getList();
    document.dispatchEvent(new CustomEvent('fa:wishlist-updated', {
      detail: { list: list, count: list.length }
    }));
  }

  window.FAWishlist = {
    add: function(product) {
      // Accept either a string handle or a product object
      var item = typeof product === 'string' ? { handle: product } : product;
      var list = getList();
      if (!list.find(function(p) { return p.handle === item.handle; })) {
        list.push(item);
        saveList(list);
      }
    },
    remove: function(handle) {
      // Accept either a string handle or a product object
      var h = typeof handle === 'string' ? handle : handle.handle;
      saveList(getList().filter(function(p) { return p.handle !== h; }));
    },
    toggle: function(product) {
      // Accept either a string handle or a product object
      var h = typeof product === 'string' ? product : product.handle;
      if (this.has(h)) { this.remove(h); return false; }
      else { this.add(product); return true; }
    },
    has: function(handle) {
      // Always search by handle string
      var h = typeof handle === 'string' ? handle : handle.handle;
      return !!getList().find(function(p) { return p.handle === h; });
    },
    getAll: function() { return getList(); },
    count: function() { return getList().length; },
    clear: function() { saveList([]); },
    merge: function(serverList) {
      var local = getList();
      serverList.forEach(function(p) {
        var item = typeof p === 'string' ? { handle: p } : p;
        if (!local.find(function(l) { return l.handle === item.handle; })) {
          local.push(item);
        }
      });
      saveList(local);
    }
  };

  // Restore saved state on all save buttons
  function restoreButtonStates() {
    document.querySelectorAll('.fa-rec-save-btn[data-handle]').forEach(function(btn) {
      var saved = FAWishlist.has(btn.getAttribute('data-handle'));
      btn.classList.toggle('is-saved', saved);
      var icon = btn.querySelector('.fa-rec-save-icon');
      if (icon) icon.setAttribute('fill', saved ? 'currentColor' : 'none');
    });
  }

  // Cross-tab sync
  window.addEventListener('storage', function(e) {
    if (e.key === STORAGE_KEY) { dispatch(); restoreButtonStates(); }
  });

  document.addEventListener('DOMContentLoaded', function() {
    restoreButtonStates();
    dispatch();
  });

  // Watch for dynamically rendered cards
  var observer = new MutationObserver(function(mutations) {
    var hasNew = mutations.some(function(m) {
      return Array.from(m.addedNodes).some(function(n) {
        return n.nodeType === 1 && (
          n.classList?.contains('fa-rec-save-btn') ||
          n.querySelector?.('.fa-rec-save-btn')
        );
      });
    });
    if (hasNew) restoreButtonStates();
  });

  document.addEventListener('DOMContentLoaded', function() {
    observer.observe(document.body, { childList: true, subtree: true });
  });

})();